import classNames from "classnames";
import {forwardRef, MouseEvent, ReactNode} from "react";

import styles from "./Chip.module.scss";

export const CHIP_VARIANTS = [
  "comingSoon",
  "beta",
  "new",
  "recommended",
  "tag",
  "navTab",
  "navTabDisabled",
  "metric",
  "count",
  "success",
  "danger",
] as const;

export const CHIP_SIZES = ["small", "smallLight", "smallMedium", "large", "tiny", "tinyMedium", "tinyBold"] as const;

export type ChipVariant = (typeof CHIP_VARIANTS)[number];
type ChipSize = (typeof CHIP_SIZES)[number];

export interface ChipProps {
  children?: ReactNode;
  className?: string;
  variant?: ChipVariant;
  size?: ChipSize;
  iconOnly?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  "aria-label"?: string;
}

export const Chip = forwardRef<HTMLDivElement, ChipProps>(
  ({children, className, variant, onClick, size = "small", iconOnly = false, "aria-label": ariaLabel}, ref) => {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div
        ref={ref}
        className={classNames(className, styles.chip, variant && styles[variant], styles[size], {
          [styles.iconOnly]: iconOnly,
        })}
        onClick={onClick}
        // role="img" makes assistive tech announce aria-label as a single unit instead of the
        // bare child text, and prevents the labelled chip from being pruned as a generic node.
        role={onClick ? "button" : ariaLabel ? "img" : undefined}
        aria-label={ariaLabel}
      >
        {children}
      </div>
    );
  }
);

Chip.displayName = "Chip";
